module.exports = __webpack_public_path__ + "static/media/02-2-galeria-04-perisur@2x.22b7e2db.jpg";